import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconTechnicianRed from "../media/icons/technician-red.png"
import iconTechnicianWhite from "../media/icons/technician-white.png"
import iconTechnicianCrossedRed from "../media/icons/technician-crossed-red.png"
import iconTechnicianCrossedWhite from "../media/icons/technician-crossed-white.png"
import iconOnlineDevicesWhite from "../media/icons/online-devices-white.png"
import {parseKasBarcodeFromUrl} from "../api/common";
import {SpacerRow} from "./SpacerRow";

/**
 * @property mainButtonOnClick - Big red button onclick listener
 * @property mainButtonTextResource - Big red button text resource
 * @property backButtonOnClick - Back arrow button onclick listener. If this is set, the back button will be shown, otherwise it will be hidden
 * @property additionalText - If this is provided, the big red button will be slightly smaller and some extra text will be shown next to it
 */
class SideBarTechnicianInfo extends React.Component {
    render() {
        let technicianAppointmentRequired = true;
        if(this.props.technicianAppointmentRequired === false){
            technicianAppointmentRequired = false;
        }


        let technicianImage = iconTechnicianRed;
        let textColor = "#333333";

        if(this.props.barStyleIsWhite){
            technicianImage = iconTechnicianWhite;
            textColor = "white";
        }

        let noTechnicianInfoRow;
        if(!technicianAppointmentRequired){
            technicianImage = iconOnlineDevicesWhite;

            noTechnicianInfoRow = <div>
                <SpacerRow/>
                <SpacerRow/>
                <SpacerRow/>
                <Row>
                    <Col xs={2}>
                        <img src={iconTechnicianCrossedWhite} style={{height:"60px",width:"60px",marginLeft:"-8px"}} alt={"technician icon"}/>
                    </Col>
                    <Col xs={10}>
                        <p className={"text-bottom-bar-subtitle-vodafone-desktop"} style={{height:"28px", marginBottom:"0", color:textColor}}>
                            {i18n.t("no_technician_required_info")}
                        </p>
                    </Col>
                </Row>
            </div>;
        }



        let titleTextResource;
        if(this.props.technicianAppointmentRequired === true){
            titleTextResource = "technician_appointment";
        }else{
            titleTextResource = "line_availability"
        }

        let titleTextContent;
        if(this.props.subText){
            titleTextContent = <Col xs={10}>
                <p className={"text-side-bar-regular"} style={{height:"28px", marginBottom:"10px", color:textColor}}>
                    {i18n.t("technician_appointment")}
                </p>
                <p className={"text-side-bar-small"} style={{height:"28px", marginBottom:"0", color:textColor}}>
                    {i18n.t(this.props.subText)}
                </p>
            </Col>;
        }else{
            titleTextContent = <Col xs={10}>
                <p className={"text-side-bar-regular"} style={{height:"28px", marginTop:"14px", color:textColor}}>
                    {i18n.t(titleTextResource)}
                </p>
            </Col>;
        }



        let titleRow = <Row>
            <Col xs={2}>
                <img src={technicianImage} style={{height:"60px",width:"60px",marginLeft:"-8px"}} alt={"technician icon"}/>
            </Col>
            {titleTextContent}
        </Row>;


        let dateRow = <Row style={{marginTop:"16px"}}>
            <Col xs={6}>
                <p className={"text-side-bar-regular text-bottom-bar-bold"} style={{height:"28px", color:textColor}}>
                    {this.props.dateText}
                </p>
            </Col>
            <Col xs={6}>
                <p className={"text-side-bar-regular text-bottom-bar-bold"} style={{height:"28px", textAlign:"right", color:textColor}}>
                    {i18n.t(this.props.timeText, this.props)}
                </p>
            </Col>
        </Row>;





        return <Container style={{padding:"16px 0 0 0"}}>
            {titleRow}
            {dateRow}
            {noTechnicianInfoRow}
        </Container>
    }
}

export default translate("translations")(SideBarTechnicianInfo);